import React from 'react';

function Delete({ size }) {
  return (
    <svg
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 5.2H16V3.6C16 3.17565 15.8314 2.76869 15.5314 2.46863C15.2313 2.16857 14.8243 2 14.4 2H9.6C9.17565 2 8.76869 2.16857 8.46863 2.46863C8.16857 2.76869 8 3.17565 8 3.6V5.2H4V6.8H5.6V18.8C5.6 19.4365 5.85286 20.047 6.30294 20.4971C6.75303 20.9471 7.36348 21.2 8 21.2H16C16.6365 21.2 17.247 20.9471 17.6971 20.4971C18.1471 20.047 18.4 19.4365 18.4 18.8V6.8H20V5.2ZM9.6 3.6H14.4V5.2H9.6V3.6ZM16.8 18.8C16.8 19.0122 16.7157 19.2157 16.5657 19.3657C16.4157 19.5157 16.2122 19.6 16 19.6H8C7.78783 19.6 7.58434 19.5157 7.43431 19.3657C7.28429 19.2157 7.2 19.0122 7.2 18.8V6.8H16.8V18.8Z"
        fill="currentColor"
      />
      <path d="M11.1996 10H9.59961V16.4H11.1996V10Z" fill="currentColor" />
      <path d="M14.4003 10H12.8003V16.4H14.4003V10Z" fill="currentColor" />
    </svg>
  );
}

export default Delete;
